export default __webpack_public_path__ + "static/media/ic-appr.5361689f.svg";